/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_ThanksInputs */

const en_feedback_thanks = /** @type {(inputs: Feedback_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanks for the feedback!`)
};

const id_feedback_thanks = /** @type {(inputs: Feedback_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makasih masukannya!`)
};

/**
* | output |
* | --- |
* | "Thanks for the feedback!" |
*
* @param {Feedback_ThanksInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const feedback_thanks = /** @type {((inputs?: Feedback_ThanksInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_ThanksInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_feedback_thanks(inputs)
	return en_feedback_thanks(inputs)
});